<div *ngIf="!isIconImage" class="c-avatar__initials">
    {{ initials }}
</div>
<img *ngIf="isIconImage && user && user[imgField]?.length"
    [alt]="user.name"
    class="c-avatar__img"
    [src]="user[imgField]" />
